import axiosAgsc from "@/store/axiosAgsc";
const resource = "/Site";

export default {
  get: (payload: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetSites`, payload);
  },
  getById: (siteGuid: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetSiteById`, {
      params: { siteGuid },
    });
  },
  getByMainId: (mainId: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetSiteByMainId`, {
      params: { mainId },
    });
  },
  getByCompanyGuid: (companyId: any = {}): any => {
    return axiosAgsc.get(`${resource}/GetSitesByCompanyId`, {
      params: { companyId },
    });
  },
};
